
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/money-fortune/SuperRich",
      function () {
        return require("private-next-pages/money-fortune/SuperRich.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/money-fortune/SuperRich"])
      });
    }
  